import ClampedText from './ClampedText';

export default ClampedText;
